(() => {
  const SELECTOR = "[data-c77-slider]";
  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));

  function initOne(root) {
    if (root.dataset.c77Ready === "true") return;
    root.dataset.c77Ready = "true";

    const track = root.querySelector("[data-c77-track]");
    const slides = Array.from(root.querySelectorAll("[data-c77-slide]"));
    const dots = Array.from(root.querySelectorAll("[data-c77-dot]"));
    const prev = root.querySelector("[data-c77-prev]");
    const next = root.querySelector("[data-c77-next]");

    const url = root.getAttribute("data-c77-url");

    // Click-to-product sin romper swipe: solo navega si NO hubo arrastre
    let c77StartX = 0;
    let c77StartY = 0;
    let c77Dragging = false;
    let c77PointerDown = false;

    const isInteractive = (el) =>
      !!el.closest("a, button, input, select, textarea, [role='button']");

    root.addEventListener("pointerdown", (e) => {
      if (!url) return;
      if (e.button != null && e.button !== 0) return; // solo click primario
      if (isInteractive(e.target)) return;

      c77PointerDown = true;
      c77Dragging = false;
      c77StartX = e.clientX;
      c77StartY = e.clientY;
    });

    root.addEventListener(
      "pointermove",
      (e) => {
        if (!c77PointerDown) return;
        const dx = e.clientX - c77StartX;
        const dy = e.clientY - c77StartY;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) c77Dragging = true;
      },
      { passive: true }
    );

    root.addEventListener("pointerup", (e) => {
      if (!url) return;
      if (!c77PointerDown) return;

      c77PointerDown = false;

      // Si hubo swipe/arrastre, no navegues
      if (c77Dragging) return;

      // Si tocó un elemento interactivo, no interfieras
      if (isInteractive(e.target)) return;

      window.location.href = url;
    });

    root.addEventListener("pointercancel", () => {
      c77PointerDown = false;
      c77Dragging = false;
    });

    // Accesibilidad teclado
    root.addEventListener("keydown", (e) => {
      if (!url) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        window.location.href = url;
      }
    });

    if (!track || slides.length <= 1) return;

    const getIndex = () => {
      const w = track.clientWidth || 1;
      return clamp(Math.round(track.scrollLeft / w), 0, slides.length - 1);
    };

    const setActive = (idx) => {
      dots.forEach((d, i) => {
        const active = i === idx;
        d.classList.toggle("is-active", active);
        d.setAttribute("aria-current", active ? "true" : "false");
      });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
      root.dataset.c77Index = String(idx);
    };

    const goTo = (idx) => {
      const w = track.clientWidth || 1;
      const target = clamp(idx, 0, slides.length - 1);
      track.scrollTo({ left: target * w, behavior: "smooth" });
      setActive(target);
    };

    if (prev) {
      prev.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(getIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(getIndex() + 1);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const i = parseInt(dot.dataset.c77Index || "0", 10);
        goTo(i);
      });
    });

    // Update on scroll
    let ticking = false;
    track.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(getIndex());
          ticking = false;
        });
      },
      { passive: true }
    );

    // Tap vs swipe detection
    let down = false;
    let moved = false;
    let sx = 0;
    let sy = 0;

    track.addEventListener(
      "pointerdown",
      (e) => {
        down = true;
        moved = false;
        sx = e.clientX;
        sy = e.clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      "pointermove",
      (e) => {
        if (!down) return;
        const dx = Math.abs(e.clientX - sx);
        const dy = Math.abs(e.clientY - sy);
        // umbral más alto para no bloquear clic normal
        if (dx > 12 && dx > dy) moved = true;
      },
      { passive: true }
    );

    track.addEventListener(
      "pointerup",
      () => {
        down = false;
        setTimeout(() => (moved = false), 0);
      },
      { passive: true }
    );

    // Click en la imagen -> ir al producto (si NO fue swipe)
    track.addEventListener("click", (e) => {
      const isControl = e.target.closest("[data-c77-prev],[data-c77-next],[data-c77-dot]");
      if (isControl) return;

      if (moved) {
        e.preventDefault();
        return;
      }

      const url = root.dataset.c77Url;
      if (url) window.location.href = url;
    });

    setActive(getIndex());
    window.addEventListener("resize", () => setActive(getIndex()), { passive: true });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
